"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMessageList = void 0;
var _api = _interopRequireDefault(require("_l/api.request"));
/**
 * 获取选手统计信息
 * @author kkdy
 * @date 2021-11-23
 * @param {any} data
 * @returns {any}
 */
var getMessageList = exports.getMessageList = function getMessageList(data) {
  return _api.default.request({
    url: '/message/getMessageList',
    method: 'post',
    data: data
  });
};